import styled from '@emotion/styled'
import { SimpleLink } from './atoms/link'
import { useState } from 'react'
import { Paragraph16 } from '../styles/typography'
import linkBlue from '../assets/logos/link-blue.svg'
import linkOrange from '../assets/logos/link-orange.svg'

export const Background = styled.div`
    width: 100%;
    background-color: ${(props) => props.theme.primaryColor.white[2]};
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding-top: 64px;
    padding-bottom: 32px;
    justify-content: center;
    align-items: center;
    z-index: 2;
`

export const MainContainer = styled.div`
    max-width: ${(props) => props.theme.containerWidth};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0px;
    position: relative;
    padding: 0px 16px;
`

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        max-width: 652px;
    }
`

export const FloatingSquareImage = styled.img`
    position: absolute;
    top: -17%;
    right: calc(50% - 540px);
    width: 33px;
    height: 92px;
    object-fit: cover;
    z-index: 5;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        left: 16px;
        top: -10%;
        left: calc(50% - 250px);
        width: 27px;
        height: 81px;
    }
`
